import React, { Component } from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Alert from 'react-s-alert';
import {saveSvgAsPng} from 'save-svg-as-png';

import { BarChartComponent } from '../../components/BarChartComponent';
import { LineChartComponent } from '../../components/LineChartComponent';
import { EditableTable } from '../../components/EditableTable';
import { ImageViewer } from '../../components/ImageViewer';

import { handledMeasurementSave, handledMeasurementDelete, getSingleElement, handledMeasurementAdd } from '../../actions/elements';
import { handleRotateImage, handleRemoveImage } from '../../actions/images';
import { ContentSplitter } from '../../components/ContentSplitter';
import { deleteConfirm } from '../../services/deleteConfirm';
import { formatBarChartData, formatLineChartData, formatBarChartDataAVG } from '../../services/formatChartData';
import { PRIMARY_LIGHT } from '../../constants/colors';

const GaleryWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin: 20px 0;
  overflow: hidden;
  overflow-y: scroll;
`;

const GaleryImageWrapper = styled.div`
  max-width: 180px;
  height: 100px;
  width: 100%;
  display: inline-block;
  overflow: hidden;
`;

const GaleryImg = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 5px;
  background-size: cover;
  background-image: url('${(props) => props.src}');
  transform: rotate(${(props) => props.rotation}deg);

  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
`;

const LightboxWrapper = styled.div`
  float: right;
  width: 400px;
`;

const ChartButton = styled.button`
  width: 40px;
  height: 24px;
  margin-top: 10px;
  background: ${(props) => props.active ? PRIMARY_LIGHT : '#fff'};
  border: 1px solid ${(props) => props.active ? PRIMARY_LIGHT : '#ccc'};
  border-radius: 3px;
  cursor: pointer;

  > img {
    height: 18px;
  }
`;

const LineTypeBox = styled.div`
  display: inline-flex;
  > button {
    margin: 0;
    height: 18px;
  }
`;

class Element extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartType: 'bar',
      lineType: 1, // 1 = normal, 2 = avg
      selectedRows: [],
      imaePreviewOpen: false,
      imageSlide: 0,
    };
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.closePreview = this.closePreview.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.openPreview = this.openPreview.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.setBarChart = this.setBarChart.bind(this);
    this.setLineChart = this.setLineChart.bind(this);
    this.setLineType = this.setLineType.bind(this);
  }

  componentDidMount() {
    this.props.getSingleElement(this.props.match.params.id);
  }

  componentDidUpdate() {
    const { error } = this.props;
    if (error) {
      Alert.error(error, {timeout: 2000});
    }
  }

  onRowSelect(e) {
    const { selectedRows } = this.state;
    const index = e.target.value;
    if (selectedRows.includes(index)) {
      this.setState({selectedRows: selectedRows.filter((item) => item !== index)});
    } else {
      this.setState({selectedRows: [...selectedRows, index]});
    }
  }

  onDelete(array) {
    this.props.handledMeasurementDelete(array.map((item) => parseInt(item, 10)));
    this.setState({selectedRows: []});
  }

  openPreview() {
    this.setState({imaePreviewOpen: true});
  }

  closePreview() {
    this.setState({imaePreviewOpen: false});
  }

  gotoNext() {
    this.setState((prevState) => ({
      imageSlide: ++prevState.imageSlide,
    }));
  }

  gotoPrevious() {
    this.setState((prevState) => ({
      imageSlide: --prevState.imageSlide,
    }));
  }

  setBarChart() {
    this.setState({chartType: 'bar'});
  }

  setLineChart() {
    this.setState({chartType: 'line'});
  }

  handleImageClick(e) {
    this.setState({
      imageSlide: parseInt(e.target.id, 10),
    });
    this.openPreview();
  }

  setLineType(type) {
    this.setState({lineType: type});
  }

  render() {
    const {
      imaePreviewOpen, imageSlide, chartType, lineType,
    } = this.state;
    const {
      selectedElement, match, displayedMeasurementProps, handleRotateImage, handleRemoveImage, handledMeasurementAdd,
    } = this.props;

    if (!selectedElement || match.params.id !== selectedElement.id.toString()) {
      return <Redirect to="/" />;
    }
    return (
      <ContentSplitter>
        <div style={{ padding: '0 10px'}}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: window.innerWidth / 2,
            float: 'left',
          }}
          >
            <div>
              <ChartButton
                onClick={() => saveSvgAsPng(document.querySelector('.recharts-surface'), 'chart.png')}
              >
                <img
                  alt="icon"
                  src="../ic-download.svg"
                />
              </ChartButton>
              <ChartButton
                active={chartType === 'bar'}
                onClick={this.setBarChart}
              >
                <img
                  alt="icon"
                  src="../bar-chart.svg"
                />
              </ChartButton>
              <ChartButton
                active={chartType === 'line'}
                onClick={this.setLineChart}
              >
                <img
                  alt="icon"
                  src="../line-chart.svg"
                />
              </ChartButton>
              {chartType === 'line' &&
                <LineTypeBox>
                  <ChartButton 
                    active={lineType === 1}
                    onClick={() => this.setLineType(1)}
                  >
                    normal
                  </ChartButton>
                  <ChartButton
                    active={lineType === 2}
                    onClick={() => this.setLineType(2)}
                  >
                    avg
                  </ChartButton>
                </LineTypeBox>
              }
            </div>
            {chartType === 'bar' ?
              <BarChartComponent
                height={(window.innerHeight / 2) - 40}
                measurements={selectedElement.measurements.map(formatBarChartData)}
                showAxis
                width={window.innerWidth / 2}
              /> :
              <LineChartComponent
                height={(window.innerHeight / 2) - 40}
                measurements={lineType === 1 ?
                  selectedElement.measurements.map(formatLineChartData) :
                  formatBarChartDataAVG(selectedElement.measurements.reduce((acc, val, i) => {
                    if (!acc[val.date]) {
                      acc[val.date] = {
                        rl: 0, qd: 0, rw: 0, cnt: 0,
                      };
                    }
                    acc[val.date].cnt += 1;
                    acc[val.date].rl += val.rl;
                    acc[val.date].qd += val.qd;
                    acc[val.date].rw += val.rw;
                    acc[val.date].date = val.date;

                    return acc;
                  }, {}))
                }
                width={window.innerWidth / 2}
              />
            }
          </div>
          <LightboxWrapper style={{height: (window.innerHeight / 2) - 40}}>
            <ImageViewer
              currentImage={imageSlide}
              images={selectedElement && selectedElement.images && selectedElement.images.map((item) => ({
                downloadLink: item.image,
                src: item.thumbnail,
                handleRotation: handleRotateImage,
                rotation: item.rotation,
                id: item.id,
              }))}
              isOpen={imaePreviewOpen}
              onClickNext={this.gotoNext}
              onClickPrev={this.gotoPrevious}
              onClose={this.closePreview}
              removeImage={(e) => deleteConfirm(() => handleRemoveImage(e))}
            />
            <GaleryWrapper>
              {selectedElement && selectedElement.images && selectedElement.images.filter((item) => Boolean(item)).map((item, i) => (
                <GaleryImageWrapper key={i}>
                  <GaleryImg
                    id={i}
                    onClick={this.handleImageClick}
                    rotation={item.rotation}
                    src={item.thumbnail}
                  />
                </GaleryImageWrapper>
              ))}
            </GaleryWrapper>
          </LightboxWrapper>
        </div>
        <EditableTable
          checkboxDelete={(array) => deleteConfirm(() => this.onDelete(array))}
          checkboxSelect={this.state.selectedRows}
          checkboxToggle={this.onRowSelect}
          data={selectedElement.measurements}
          edit={false}
          handledMeasurementAdd={handledMeasurementAdd}
          onSave={this.props.handledMeasurementSave}
          selected={displayedMeasurementProps}
          selectedElementId={selectedElement.id}
        />
      </ContentSplitter>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedElement: state.elements.selectedElement,
    displayedMeasurementProps: state.elements.displayedMeasurementProps,
    error: state.elements.error,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    handledMeasurementSave,
    handledMeasurementDelete,
    getSingleElement,
    handleRotateImage,
    handledMeasurementAdd,
    handleRemoveImage,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Element);



// WEBPACK FOOTER //
// ./src/containers/Element/content.js